module.exports = __webpack_public_path__ + "img/32.5802ff93.jpg";